<script setup lang="ts">
import { Component as ComponentType } from 'vue'

interface Props {
  state?: 'pill' | 'large-circle' | 'circle' | 'transparent' | 'fill'
  active?: boolean
  disabled?: boolean
  icon?: ComponentType
}

// type Props = {
//   disabled?: boolean
//   icon?: ComponentType
// } & (
//   | {
//       state: 'pill'
//       active?: boolean
//     }
//   | {
//       state: 'large-circle' | 'circle'
//     }
// )

withDefaults(defineProps<Props>(), {
  state: 'circle',
  active: false,
  disabled: false,
})
</script>

<template>
  <button
    class="button"
    :class="{
      'button_default button_round': state === 'circle',
      button_pill: state === 'pill',
      'button_large button_round': state === 'large-circle',
      button_disabled: disabled,
      button_transparent: state === 'transparent',
      'button_fill button_pill': state === 'fill',
      active,
    }"
  >
    <component v-if="icon" :is="icon" />
    <slot />
  </button>
</template>

<style scoped lang="scss">
.button {
  @extend %hover-transition;
  border: 1.5px solid transparent;

  color: $primary-text;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -10px;
    cursor: pointer;
  }

  &_fill {
    background-color: $primary-green !important;
    --svg-col: #{$white} !important;
  }

  &_transparent {
    padding: 8px;
  }

  &_round {
    border-radius: 50%;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    border-color: $sub-green;

    &:hover {
      --svg-col: #{$white};
    }
  }

  &_default {
    background-color: $sub-green;
    --svg-col: #{$primary-green};
    padding: 10px;

    &:hover {
      background-color: $primary-green;
      --svg-col: #{$white};
      border-color: $primary-green;
    }
  }

  &_large {
    padding: 14px;
    background-color: $primary-green;
    border-color: $primary-green;
    --svg-col: #{$white};
    &:hover {
      background-color: $hover-green;
      border-color: $hover-green;
    }
    &:active {
      background-color: $click-green;
      border-color: $click-green;
    }
  }

  &_pill {
    display: flex;
    gap: 4px;
    align-items: center;
    padding: 10px;
    border-radius: 30px;
    border-color: transparent;
    background-color: transparent;
    color: $primary-text;
    --svg-col: #{$primary-text};
    @include h5-6;

    &.active {
      background-color: $sub-green;
      border-color: $sub-green;
    }

    &:hover {
      border-color: $primary-green;
    }
  }

  &__disabled {
    pointer-events: none;
    background-color: $white !important;
    color: $ui-gray-3 !important;
    --svg-col: #{$ui-gray-3} !important;
    border-color: $ui-gray-3 !important;
  }
}
</style>
